// import { Link, useNavigate } from "react-router-dom";
// import MaxiPitchImage from "/images/maxipitch.png";
// import neslogo from "../../assets/images/nselogo.jpg";
// export default function Footer() {
//   const navigate = useNavigate();

//   const handlePricingClick = () => {
//     const token = localStorage.getItem("token");

//     if (token) {
//       navigate("/pricing");
//     } else {
//       navigate("/pricing-plans");
//     }
//   };
//   return (
//     <footer className="bg-white border-t border-gray-200 py-6 relative z-10 max-md:px-2 pt-10 ">
//       <div className="container mx-auto px-4 max-md:px-1">
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
//           <div className="space-y-1">
//             <img
//               src={MaxiPitchImage}
//               alt="MaxiPitch"
//               className="h-7 max-md:h-7  cursor-pointer"
//               onClick={() => navigate("/")}
//             />
//             <p className="text-base max-md:text-[14px] pt-2 font-semibold text-black/80 pl-1">
//               Digikore Studios Limited, <br /> Lalwani Triumph, Viman Nagar,
//               Pune, MH 411014
//             </p>
//           </div>
//           <div>
//             <h3 className="font-semibold text-lg max-md:text-xl mb-0 text-gray-900 max-md:pl-1 max-md:pt-1">
//               Listed on NSE
//             </h3>
//             <img
//               src={neslogo}
//               alt="MaxiPitch"
//               className="h-10 cursor-pointer mt-2"
//               onClick={() => navigate("/")}
//             />
//           </div>

//           <div>
//             <h3 className="font-semibold text-lg max-md:text-md mb-3 text-gray-900">
//               Product
//             </h3>

//             <ul className="space-y-2 text-sm mb-2">
//               <li>
//                 <button
//                   onClick={handlePricingClick}
//                   className="text-gray-600 hover:text-blue-600"
//                 >
//                   Pricing
//                 </button>
//               </li>
//             </ul>
//             <ul className="space-y-2 text-sm">
//               <li>
//                 <button
//                   onClick={() => navigate("/how-to-use")}
//                   className="text-gray-600 hover:text-blue-600"
//                 >
//                   How To Use
//                 </button>
//               </li>

//               <li>
//                 <Link
//                   to="/maxipitch-benefits"
//                   className="text-gray-600 hover:text-blue-600"
//                 >
//                   MaxiPitch Benefits
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/blog" className="text-gray-600 hover:text-blue-600">
//                   Blog
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           <div>
//             <h3 className="font-semibold text-lg max-md:text-md mb-3 text-gray-900">
//               Support
//             </h3>
//             <ul className="space-y-2 text-sm">
//               <li>
//                 <Link
//                   to="/about-us"
//                   className="text-gray-600 hover:text-blue-600 "
//                 >
//                   About Us
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact-us"
//                   className="text-gray-600 hover:text-blue-600 "
//                 >
//                   Contact Us
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/faq" className="text-gray-600 hover:text-blue-600">
//                   FAQ
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           <div>
//             <h3 className="font-semibold text-lg max-md:text-md mb-3 text-gray-900">
//               Legal
//             </h3>
//             <ul className="space-y-2 text-sm">
//               <li>
//                 <Link
//                   to="/privacy-policy"
//                   className="text-gray-600 hover:text-blue-600 "
//                 >
//                   Privacy Policy
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/terms-and-Conditions"
//                   className="text-gray-600 hover:text-blue-600 "
//                 >
//                   Terms Of Service
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/cancellation-and-refund"
//                   className="text-gray-600 hover:text-blue-600 "
//                 >
//                   Cancellation And Refund
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>

//         <div className="mt-8 pt-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600">
//           <p className="text-center md:text-left">
//             &copy; {new Date().getFullYear()} Maxipitch. All rights reserved
//           </p>
//           <p className="text-center md:text-right mt-2 md:mt-0">
//             MaxiPitch - Get new customers every day, automatically.
//           </p>
//           {/* <div className="flex space-x-4 mt-4 md:mt-0">
//             <Link to="#" className="hover:text-blue-600 ">
//               Twitter
//             </Link>
//             <Link to="#" className="hover:text-blue-600 ">
//               LinkedIn
//             </Link>
//             <Link to="#" className="hover:text-blue-600 ">
//               Facebook
//             </Link>
//           </div> */}
//         </div>
//       </div>
//     </footer>
//   );
// }

import { Link, useNavigate } from "react-router-dom";
import MaxiPitchImage from "/images/maxipitch.png";
import nseLogo from "../../assets/images/nselogo.jpg";

export default function Footer() {
  const navigate = useNavigate();

  const handlePricingClick = () => {
    const token = localStorage.getItem("token");
    navigate(token ? "/pricing" : "/pricing-plans");
  };

  const linkClass =
    "text-sm text-gray-600 transition-colors duration-200 hover:text-[#8B5E3C]";

  return (
    <footer className="relative overflow-hidden border-t border-[#efedec bg-white">
      {/* Footer content */}
      <div className="relative z-10 mx-auto max-w-7xl px-5 pb-28 pt-12 sm:px-8 lg:px-10 lg:pb-34 lg:pt-16">
        <div className="grid grid-cols-2 gap-x-8 gap-y-10 md:grid-cols-3 lg:grid-cols-[1.5fr_1fr_1fr_1fr_1.25fr]">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <button
              type="button"
              onClick={() => navigate("/")}
              className="inline-flex"
              aria-label="Go to MaxiPitch home"
            >
              <img
                src={MaxiPitchImage}
                alt="MaxiPitch"
                className="h-8 w-auto cursor-pointer object-contain"
              />
            </button>

            <p className="mt-5 max-w-[280px] text-sm font-medium leading-6 text-gray-600">
              Digikore Studios Limited,
              <br />
              Lalwani Triumph, Viman Nagar,
              <br />
              Pune, Maharashtra 411014
            </p>
          </div>

          {/* NSE */}
          <div>
            <h3 className="mb-4 text-base font-semibold text-gray-900">
              Listed on NSE
            </h3>

            <div className="inline-flex rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-sm">
              <img
                src={nseLogo}
                alt="Listed on NSE"
                className="h-8 w-auto object-contain"
              />
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="mb-4 text-base font-semibold text-gray-900">
              Product
            </h3>

            <ul className="space-y-3">
              <li>
                <button
                  type="button"
                  onClick={handlePricingClick}
                  className={linkClass}
                >
                  Pricing
                </button>
              </li>

              <li>
                <Link to="/how-to-use" className={linkClass}>
                  How To Use
                </Link>
              </li>

              <li>
                <Link to="/maxipitch-benefits" className={linkClass}>
                  MaxiPitch Benefits
                </Link>
              </li>

              <li>
                <Link to="/blog" className={linkClass}>
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="mb-4 text-base font-semibold text-gray-900">
              Support
            </h3>

            <ul className="space-y-3">
              <li>
                <Link to="/about-us" className={linkClass}>
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/contact-us" className={linkClass}>
                  Contact Us
                </Link>
              </li>

              <li>
                <Link to="/faq" className={linkClass}>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="mb-4 text-base font-semibold text-gray-900">
              Legal
            </h3>

            <ul className="space-y-3">
              <li>
                <Link to="/privacy-policy" className={linkClass}>
                  Privacy Policy
                </Link>
              </li>

              <li>
                <Link to="/terms-and-Conditions" className={linkClass}>
                  Terms of Service
                </Link>
              </li>

              <li>
                <Link to="/cancellation-and-refund" className={linkClass}>
                  Cancellation and Refund
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom information */}
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-[#dfd2c8] pt-5 text-xs text-gray-500 md:flex-row">
          <p className="text-center md:text-left">
            © {new Date().getFullYear()} MaxiPitch. All rights reserved.
          </p>

          <p className="text-center md:text-right">
            Get new customers every day, automatically.
          </p>
        </div>
      </div>

      {/* Large brown background name */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-[-5.5vw] left-1/2 hidden -translate-x-1/2 select-none whitespace-nowrap text-[18vw] font-extrabold leading-none tracking-[-0.075em] text-[#d5e1ff]/40 lg:block"
      >
        MaxiPitch
      </div>

      {/* Mobile background name */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-1 left-1/2 -translate-x-1/2 select-none whitespace-nowrap text-[24vw] font-extrabold leading-none tracking-[-0.075em] text-[#d5e1ff]/40 lg:hidden"
      >
        MaxiPitch
      </div>
    </footer>
  );
}